/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_TitleInputs */

const en_drastic_tech_title = /** @type {(inputs: Drastic_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drastic Technologies`)
};

const fr_drastic_tech_title = /** @type {(inputs: Drastic_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drastic Technologies`)
};

const de_drastic_tech_title = /** @type {(inputs: Drastic_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drastic Technologies`)
};

const it_drastic_tech_title = /** @type {(inputs: Drastic_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologie drastiche`)
};

const ru_drastic_tech_title = /** @type {(inputs: Drastic_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Драстик Технологии`)
};

const es_drastic_tech_title = /** @type {(inputs: Drastic_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologías drásticas`)
};

const zh_cn2_drastic_tech_title = /** @type {(inputs: Drastic_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`德拉斯蒂克科技`)
};

const ja_drastic_tech_title = /** @type {(inputs: Drastic_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドラスティックテクノロジーズ`)
};

const hi_drastic_tech_title = /** @type {(inputs: Drastic_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कठोर प्रौद्योगिकियां`)
};

const pt_pt2_drastic_tech_title = /** @type {(inputs: Drastic_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologias drásticas`)
};

/**
* | output |
* | --- |
* | "Drastic Technologies" |
*
* @param {Drastic_Tech_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_title = /** @type {((inputs?: Drastic_Tech_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_title(inputs)
	if (locale === "de") return de_drastic_tech_title(inputs)
	if (locale === "it") return it_drastic_tech_title(inputs)
	if (locale === "ru") return ru_drastic_tech_title(inputs)
	if (locale === "es") return es_drastic_tech_title(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_title(inputs)
	if (locale === "ja") return ja_drastic_tech_title(inputs)
	if (locale === "hi") return hi_drastic_tech_title(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_title(inputs)
	return en_drastic_tech_title(inputs)
});